module.exports = __webpack_public_path__ + "static/media/aniversare.02c4fcf6.jpg";